<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <v-alert
      v-model="flashError"
      dense
      border="left"
      type="error"
      dismissible
      elevation="2"
    >
      {{ flashErrorMessage }}
    </v-alert>
    <div>
      <v-data-table
        :headers="headers"
        :items="provinces"
        :options.sync="options"
        :server-items-length="totalProvinces"
        :loading="loading"
        loading-text="Loading... Please wait"
        :item-class="rowClass"
        class="d-print-table"
        :footer-props="{
          itemsPerPageOptions: [5, 10, 25, 50],
          // showFirstLastPage: true,
        }"
        sort-by="id_prov"
        :style="{ padding: '10px' }"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>List Data</v-toolbar-title>
            <v-divider class="mx-4" inset vertical />
            <v-spacer />
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="warning"
                  class="mb-2"
                  @click="getData"
                  :loading="loading"
                  :disabled="loading"
                  ><v-icon>mdi-restart</v-icon
                  ><template v-slot:loader>
                    <span class="custom-loader">
                      <v-icon light>mdi-cached</v-icon>
                    </span>
                  </template>
                </v-btn>
                <v-btn
                  color="primary"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  :style="{ 'margin-right': '10px' }"
                  v-on="on"
                >
                  New Province
                </v-btn>
              </template>
              <v-card>
                <v-form>
                  <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            v-model="editedItem.id_prov"
                            label="Kode Provinsi"
                            :disabled="view"
                            :error-messages="idProvErrors"
                            @change="$v.editedItem.id_prov.$touch()"
                            @blur="$v.editedItem.id_prov.$touch()"
                          />
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            v-model="editedItem.nama"
                            label="Nama Provinsi"
                            :error-messages="namaErrors"
                            @change="$v.editedItem.nama.$touch()"
                            @blur="$v.editedItem.nama.$touch()"
                            :disabled="view"
                          />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer />
                    <v-btn color="blue darken-1" text @click="close">
                      Cancel
                    </v-btn>
                    <v-btn
                      v-if="!view"
                      color="blue darken-1"
                      text
                      :loading="loading"
                      :disabled="loading"
                      @click="save"
                    >
                      Save
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogDelete" max-width="500px">
              <v-card>
                <v-card-title class="headline"
                  >Are you sure you want to delete this item?</v-card-title
                >
                <v-card-actions>
                  <v-spacer />
                  <v-btn color="blue darken-1" text @click="closeDelete"
                    >Cancel</v-btn
                  >
                  <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                    >OK</v-btn
                  >
                  <v-spacer />
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
          <v-card :style="{ margin: '10px' }">
            <v-card-actions
              :style="{
                'padding-bottom': '0px',
                'padding-top': '0px',
              }"
            >
              <v-btn color="orange lighten-2" text> Search Criteria </v-btn>

              <v-switch color="primary" value v-model="show" />
            </v-card-actions>

            <v-expand-transition>
              <div v-show="show">
                <v-divider />

                <v-container
                  :style="{
                    'padding-bottom': '0px',
                    'padding-top': '0px',
                  }"
                >
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="search.nama"
                        type="text"
                        label="Nama Provinsi"
                        v-on:keyup.enter="getData"
                      />
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="search.id_prov"
                        type="text"
                        label="Kode Provinsi"
                        v-on:keyup.enter="getData"
                      />
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-btn
                        color="success"
                        class="mb-2 ml-2 mr-2"
                        @click="getData"
                        ><v-icon>mdi-magnify</v-icon></v-btn
                      >
                      <v-btn
                        color="warning"
                        class="mb-2 ml-2 mr-2"
                        @click="clearSearch"
                        ><v-icon>mdi-broom</v-icon></v-btn
                      >
                    </v-col>
                  </v-row>
                </v-container>
              </div>
            </v-expand-transition>
          </v-card>
        </template>
        <template v-slot:item="{ item, index }">
          <tr :key="index" :style="{ cursor: 'pointer' }">
            <td class="d-block d-sm-table-cell d-print-table-cell">
              {{ item.id_prov }}
            </td>
            <td class="d-block d-sm-table-cell d-print-table-cell">
              {{ item.nama }}
            </td>
            <td class="d-block d-sm-table-cell d-print-table-cell">
              <v-icon small class="mr-2" @click="viewItem(item)">
                mdi-eye
              </v-icon>
              <v-icon small class="mr-2" @click="editItem(item)">
                mdi-pencil
              </v-icon>
              <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
            </td>
          </tr>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="getData"> Reset </v-btn>
        </template>
      </v-data-table>
    </div>
  </v-card>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, numeric } from 'vuelidate/lib/validators';
import { date } from '../../lib/helpers';

export default {
  mixins: [validationMixin],
  validations: {
    editedItem: {
      nama: { required },
      id_prov: {
        required,
        isUnique() {
          return (
            this.errorValidation != null &&
            (this.errorValidation.id_prov == null ||
              this.errorValidation.id_prov.length < 1)
          );
        },
        numeric,
      },
    },
  },
  data: () => ({
    search: {
      nama: '',
      id_prov: '',
    },
    show: false,
    view: false,
    limit: '5',
    page: '1',
    options: {},
    dialog: false,
    dialogDelete: false,
    headers: [
      { text: 'Kode Provinsi', value: 'id_prov' },
      { text: 'Nama Provinsi', value: 'nama' },
      { text: 'Actions', value: 'actions', sortable: false },
    ],
    editedIndex: -1,
    editedItem: {
      id: '',
      nama: '',
      id_prov: '',
    },
    defaultItem: {
      id: '',
      nama: '',
      id_prov: '',
    },
  }),

  computed: {
    formTitle() {
      let item = '';
      if (this.editedIndex != -1) {
        if (this.editedIndex == -2) {
          item = 'View Item';
        } else item = 'Edit Item';
      } else {
        item = 'New Item';
      }

      return item;
    },
    flashErrorMessage() {
      return this.$store.state.master.daerah.flashErrorMessage;
    },

    flashError: {
      get() {
        return this.$store.state.master.daerah.flashError;
      },
      set() {
        this.$store.commit('master/daerah/setFlashErrorMessage', '');
      },
    },

    errorValidation() {
      return this.$store.state.master.daerah.errors;
    },
    loading() {
      return this.$store.state.master.daerah.loading;
    },
    provinces() {
      return this.$store.state.master.daerah.provinsi;
    },
    totalProvinces() {
      return this.$store.state.master.daerah.totalProvinsi;
    },

    idProvErrors() {
      const errors = [];
      if (!this.$v.editedItem.id_prov.$dirty) {
        return errors;
      }
      if (!this.$v.editedItem.id_prov.required)
        errors.push('Kode Provinsi is required.');
      if (!this.$v.editedItem.id_prov.numeric) errors.push('Must be numeric');
      if (!this.$v.editedItem.id_prov.isUnique) {
        if (this.errorValidation.id_prov != null) {
          this.errorValidation.id_prov.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    namaErrors() {
      const errors = [];
      if (!this.$v.editedItem.nama.$dirty) return errors;
      if (!this.$v.editedItem.nama.required)
        errors.push('Nama Provinsi is required');
      return errors;
    },
  },

  watch: {
    dialog(val) {
      if (!val) this.close();
    },
    dialogDelete(val) {
      if (!val) this.closeDelete();
    },
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },

    show() {
      if (!this.show) {
        this.search.nama = '';
        this.search.id_prov = '';
        this.$nextTick(() => {
          this.getData();
        });
      }
    },
  },

  async mounted() {
    this.getData();
  },

  methods: {
    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },

    clearSearch() {
      this.search.nama = '';
      this.search.id_prov = '';
    },

    getData() {
      this.$store.commit('master/daerah/setFlashErrorMessage', '');
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      this.$store.dispatch('master/daerah/fetchAllDaerah', {
        date,
        page,
        itemsPerPage,
        sortBy,
        sortDesc,
        search: this.search,
        category: 'provinsi',
      });
    },

    viewItem(item) {
      this.editedIndex = this.$store.state.master.daerah.provinsi.indexOf(item);
      this.editedItem = { ...item };
      this.view = true;
      this.editedIndex = -2;
      this.dialog = true;
    },

    editItem(item) {
      this.view = false;
      const newItem = { ...item, id: item.id_prov };
      this.editedIndex = this.$store.state.master.daerah.provinsi.indexOf(item);
      this.editedItem = { ...newItem };
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.$store.state.master.daerah.provinsi.indexOf(item);
      this.editedItem = { ...item };
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      await this.$store
        .dispatch('master/daerah/deleteDaerah', {
          date,
          payload: this.editedItem,
          index: this.editedItem.id_prov,
          category: 'provinsi',
        })
        .then(() => {
          this.closeDelete();
        });
    },

    close() {
      this.resetUniqueValidation();
      this.view = false;
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },

    closeFlash() {
      this.$store.commit('master/daerah/setFlashErrorMessage', '');
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },

    checkProvince(item) {
      return item.id == this.editedItem.province.id;
    },

    resetUniqueValidation() {
      this.$store.commit('master/daerah/clearErrors');
    },

    async exportFile() {
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      await this.$store.dispatch('master/daerah/export', {
        date,
        page,
        itemsPerPage,
        sortBy,
        sortDesc,
        search: this.search,
        category: 'provinsi',
      });
    },

    async save() {
      this.$store.commit('master/daerah/setFlashErrorMessage', '');
      this.resetUniqueValidation();
      this.$v.$touch();
      if (!this.$v.$invalid) {
        const provinsi = this.editedItem;
        if (this.editedIndex > -1) {
          await this.$store
            .dispatch('master/daerah/updateDaerah', {
              date,
              payload: provinsi,
              index: this.editedIndex,
              category: 'provinsi',
            })
            .then((status) => {
              if (status) {
                this.close();
              }
            });
        } else {
          await this.$store
            .dispatch('master/daerah/createDaerah', {
              date,
              payload: provinsi,
              category: 'provinsi',
            })
            .then((status) => {
              if (status) {
                this.close();
              }
            });
        }
      }
    },
  },
};
</script>

<style>
.max-width-col td {
  white-space: nowrap;
  overflow: hidden;
  max-width: 250px;
  text-overflow: ellipsis;
}
</style>
